// BANGUOJA PDP v2 – karuselės „Daugiau iš kolekcijos“ (sections/bj-collection-more.liquid) ir „Jums taip pat gali patikti“ (sections/bj-related-more.liquid).
// Naršymas: braukimas (scroll-snap), rodyklės ant nuotraukų ir brūkšneliai (puslapiai) apačioje.
if (!customElements.get('bj-coll-more')) {
  class BjCollMore extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-bj-cm-track]');
      this.prev = this.querySelector('[data-bj-cm-prev]');
      this.next = this.querySelector('[data-bj-cm-next]');
      this.dash = this.querySelector('[data-bj-cm-dash]');
      if (!this.track) return;
      if (this.dataset.bjDedupe && !this.dedupe()) return;

      this.prev.addEventListener('click', () => this.go(-1));
      this.next.addEventListener('click', () => this.go(1));
      this.dash.addEventListener('click', (event) => {
        const item = event.target.closest('[data-page]');
        if (item) this.toPage(this.dashToPage(parseInt(item.dataset.page, 10)));
      });
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.build());
      this.resizeObserver.observe(this.track);
      this.build();
    }

    // „Jums taip pat gali patikti“: išmetama ši prekė ir tai, kas jau rodoma „Daugiau iš kolekcijos“; paliekama iki data-bj-max
    dedupe() {
      const host = this.closest('product-recommendations');
      const skip = new Set(host ? [String(host.getAttribute('product'))] : []);
      document.querySelectorAll(this.dataset.bjDedupe).forEach((el) => skip.add(el.dataset.pid));
      const max = parseInt(this.dataset.bjMax, 10) || 24;
      let count = 0;
      Array.from(this.track.children).forEach((card) => {
        if (skip.has(card.dataset.pid) || count >= max) {
          card.remove();
        } else {
          skip.add(card.dataset.pid);
          count += 1;
        }
      });
      if (!count) {
        const box = this.closest('.bj-more');
        if (box) box.remove();
        return false;
      }
      return true;
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    get step() {
      const card = this.track.firstElementChild;
      if (!card) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const perView = Math.max(1, Math.floor((this.track.clientWidth + gap) / (card.getBoundingClientRect().width + gap) + 0.05));
      return perView * (card.offsetWidth + gap);
    }

    get pages() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      return max <= 1 ? 1 : Math.ceil(max / this.step) + 1;
    }

    // Brūkšnelių daugiausia 8 – kai puslapių daugiau (pvz. 24 papuošalai telefone), vienas brūkšnelis apima kelis puslapius
    build() {
      this.pageCount = this.pages;
      const dashes = Math.min(this.pageCount, 8);
      this.dash.innerHTML = dashes > 1 ? Array.from({ length: dashes }, (_, i) => `<i data-page="${i}"></i>`).join('') : '';
      this.update();
    }

    dashToPage(index) {
      const dashes = this.dash.children.length;
      return dashes > 1 ? Math.round((index * (this.pageCount - 1)) / (dashes - 1)) : 0;
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const left = this.track.scrollLeft;
      this.prev.hidden = left <= 4;
      this.next.hidden = left >= max - 4;
      const dashes = this.dash.children.length;
      if (!dashes) return;
      const pages = this.pageCount || dashes;
      const page = left >= max - 4 ? pages - 1 : Math.round(left / this.step);
      const current = pages > 1 ? Math.round((page * (dashes - 1)) / (pages - 1)) : 0;
      Array.from(this.dash.children).forEach((item, index) => item.classList.toggle('is-active', index === current));
    }

    toPage(page) {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.track.scrollTo({ left: Math.min(max, page * this.step), behavior: 'smooth' });
    }

    go(direction) {
      this.track.scrollBy({ left: direction * this.step, behavior: 'smooth' });
    }
  }

  customElements.define('bj-coll-more', BjCollMore);
}
